import { Helmet } from "react-helmet-async";
import { useState, useEffect } from "react";
import { Link } from "react-router-dom";

function Careers() {
  const [companyLanguage, setCompanyLanguage] = useState('en');

  useEffect(() => {
    // Get company language from localStorage
    const lang = localStorage.getItem("companyLanguage") || 'en';
    setCompanyLanguage(lang);
    
    // Listen for language updates
    const handleStorageChange = () => {
      const updatedLang = localStorage.getItem("companyLanguage") || 'en';
      setCompanyLanguage(updatedLang);
    };
    
    window.addEventListener('companyDataUpdated', handleStorageChange);
    
    // Check periodically
    const interval = setInterval(() => {
      const updatedLang = localStorage.getItem("companyLanguage") || 'en';
      if (updatedLang !== companyLanguage) {
        setCompanyLanguage(updatedLang);
      }
    }, 2000);

    return () => {
      window.removeEventListener('companyDataUpdated', handleStorageChange);
      clearInterval(interval);
    };
  }, [companyLanguage]);

  const isUrdu = companyLanguage === 'ur';

  // Dummy job openings data
  const jobOpenings = [
    {
      id: 1,
      title: "Senior Software Engineer",
      titleUrdu: "سینئر سافٹ ویئر انجینئر",
      department: "Engineering",
      departmentUrdu: "انجینئرنگ",
      location: "Islamabad, Pakistan",
      locationUrdu: "اسلام آباد، پاکستان",
      type: "Full-time",
      typeUrdu: "فل ٹائم",
      description: "We are looking for an experienced software engineer to join our team and help build innovative solutions for commission agents.",
      descriptionUrdu: "ہم اپنی ٹیم میں شامل ہونے اور کمیشن ایجنٹس کے لیے جدید حل بنانے میں مدد کرنے کے لیے ایک تجربہ کار سافٹ ویئر انجینئر تلاش کر رہے ہیں۔",
      requirements: [
        "5+ years of experience in software development",
        "Strong knowledge of React, Node.js, and MongoDB",
        "Experience with RESTful APIs",
        "Good problem-solving skills"
      ],
      requirementsUrdu: [
        "سافٹ ویئر ڈویلپمنٹ میں 5+ سال کا تجربہ",
        "React، Node.js، اور MongoDB کی مضبوط معلومات",
        "RESTful APIs کا تجربہ",
        "اچھی مسئلہ حل کرنے کی صلاحیتیں"
      ]
    },
    {
      id: 2,
      title: "UX/UI Designer",
      titleUrdu: "یو ایکس/یو آئی ڈیزائنر",
      department: "Design",
      departmentUrdu: "ڈیزائن",
      location: "Islamabad, Pakistan",
      locationUrdu: "اسلام آباد، پاکستان",
      type: "Full-time",
      typeUrdu: "فل ٹائم",
      description: "Join our design team to create beautiful and intuitive user interfaces for our business management platform.",
      descriptionUrdu: "ہمارے کاروباری انتظامی پلیٹ فارم کے لیے خوبصورت اور بدیہی صارف انٹرفیس بنانے کے لیے ہماری ڈیزائن ٹیم میں شامل ہوں۔",
      requirements: [
        "3+ years of UI/UX design experience",
        "Proficiency in Figma, Adobe XD, or similar tools",
        "Strong portfolio showcasing design skills",
        "Understanding of user-centered design principles"
      ],
      requirementsUrdu: [
        "UI/UX ڈیزائن میں 3+ سال کا تجربہ",
        "Figma، Adobe XD، یا اسی طرح کے ٹولز میں مہارت",
        "ڈیزائن کی مہارتوں کو ظاہر کرنے والا مضبوط پورٹ فولیو",
        "صارف مرکز ڈیزائن اصولوں کی سمجھ"
      ]
    },
    {
      id: 3,
      title: "Business Development Manager",
      titleUrdu: "کاروباری ترقی کا مینیجر",
      department: "Business Development",
      departmentUrdu: "کاروباری ترقی",
      location: "Islamabad, Pakistan",
      locationUrdu: "اسلام آباد، پاکستان",
      type: "Full-time",
      typeUrdu: "فل ٹائم",
      description: "We need a dynamic business development manager to expand our reach in the commission agent market.",
      descriptionUrdu: "ہمیں کمیشن ایجنٹ مارکیٹ میں اپنی رسائی کو بڑھانے کے لیے ایک متحرک کاروباری ترقی کا مینیجر درکار ہے۔",
      requirements: [
        "5+ years in business development or sales",
        "Experience in B2B software sales",
        "Strong communication and negotiation skills",
        "Ability to build and maintain client relationships"
      ],
      requirementsUrdu: [
        "کاروباری ترقی یا فروخت میں 5+ سال",
        "B2B سافٹ ویئر فروخت کا تجربہ",
        "مضبوط مواصلات اور مذاکرات کی مہارتیں",
        "کلائنٹ کے تعلقات بنانے اور برقرار رکھنے کی صلاحیت"
      ]
    },
    {
      id: 4,
      title: "Customer Support Specialist",
      titleUrdu: "کسٹمر سپورٹ ماہر",
      department: "Support",
      departmentUrdu: "سپورٹ",
      location: "Islamabad, Pakistan",
      locationUrdu: "اسلام آباد، پاکستان",
      type: "Full-time",
      typeUrdu: "فل ٹائم",
      description: "Help our customers succeed by providing excellent support and guidance on using our platform.",
      descriptionUrdu: "ہمارے پلیٹ فارم کے استعمال پر بہترین سپورٹ اور رہنمائی فراہم کرکے اپنے کسٹمرز کو کامیاب بنانے میں مدد کریں۔",
      requirements: [
        "2+ years in customer support",
        "Excellent communication skills in Urdu and English",
        "Patience and problem-solving attitude",
        "Technical knowledge of web applications"
      ],
      requirementsUrdu: [
        "کسٹمر سپورٹ میں 2+ سال",
        "اردو اور انگریزی میں بہترین مواصلاتی مہارتیں",
        "صبر اور مسئلہ حل کرنے کا رویہ",
        "ویب ایپلی کیشنز کی تکنیکی معلومات"
      ]
    }
  ];

  return (
    <>
      <Helmet>
        <title>{companyLanguage === 'ur' ? 'کریئرز - Galla Mandi Bills & Khata' : 'Careers - Galla Mandi Bills & Khata'}</title>
      </Helmet>
      
      <div
        className={`${isUrdu ? 'font-urdu' : ''} bg-brand-background min-h-screen`}
        style={isUrdu ? { fontFamily: "'Noto Nastaliq Urdu', 'Jameel Noori Nastaleeq', 'Al Qalam Taj Nastaleeq', serif" } : {}}
        dir={isUrdu ? 'rtl' : 'ltr'}
      >
        {/* Hero Section */}
        <section className="bg-gradient-to-r from-brand-header to-green-700 text-white py-20">
          <div className="container mx-auto px-4 text-center">
            <h1 className="text-5xl font-bold mb-4">
              {companyLanguage === 'ur' ? 'کریئرز' : 'Careers'}
            </h1>
            <p className="text-xl opacity-90">
              {companyLanguage === 'ur' 
                ? 'ہمارے ساتھ کام کریں اور مستقبل بنائیں' 
                : 'Join us and build the future'}
            </p>
          </div>
        </section>

        {/* Why Join Us Section */}
        <section className={`py-16 bg-white ${isUrdu ? 'font-urdu' : ''}`} style={isUrdu ? { fontFamily: "'Noto Nastaliq Urdu', 'Jameel Noori Nastaleeq', 'Al Qalam Taj Nastaleeq', serif" } : {}}>
          <div className="container mx-auto px-4">
            <h2 className="text-3xl font-bold text-center mb-12 text-gray-900">
              {companyLanguage === 'ur' ? 'ہمارے ساتھ کیوں شامل ہوں؟' : 'Why Join Us?'}
            </h2>
            <div className="grid md:grid-cols-3 gap-8">
              <div className="text-center p-6 bg-brand-background rounded-lg">
                <div className="text-4xl mb-4">🚀</div>
                <h3 className="text-xl font-bold mb-2 text-gray-900">
                  {companyLanguage === 'ur' ? 'تیز ترقی' : 'Fast Growth'}
                </h3>
                <p className="text-gray-600">
                  {companyLanguage === 'ur' 
                    ? 'ایک تیزی سے بڑھتی ہوئی کمپنی میں اپنے کیریئر کو آگے بڑھائیں' 
                    : 'Advance your career in a fast-growing company'}
                </p>
              </div>
              <div className="text-center p-6 bg-brand-background rounded-lg">
                <div className="text-4xl mb-4">💡</div>
                <h3 className="text-xl font-bold mb-2 text-gray-900">
                  {companyLanguage === 'ur' ? 'جدت' : 'Innovation'}
                </h3>
                <p className="text-gray-600">
                  {companyLanguage === 'ur' 
                    ? 'جدید ٹیکنالوجی کے ساتھ کام کریں اور نئے حل بنائیں' 
                    : 'Work with cutting-edge technology and build new solutions'}
                </p>
              </div>
              <div className="text-center p-6 bg-brand-background rounded-lg">
                <div className="text-4xl mb-4">👥</div>
                <h3 className="text-xl font-bold mb-2 text-gray-900">
                  {companyLanguage === 'ur' ? 'بہترین ٹیم' : 'Great Team'}
                </h3>
                <p className="text-gray-600">
                  {companyLanguage === 'ur' 
                    ? 'ماہرین کی ایک متنوع اور معاون ٹیم کے ساتھ کام کریں' 
                    : 'Work with a diverse and supportive team of experts'}
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Job Openings Section */}
        <section className={`py-20 ${isUrdu ? 'font-urdu' : ''}`} style={isUrdu ? { fontFamily: "'Noto Nastaliq Urdu', 'Jameel Noori Nastaleeq', 'Al Qalam Taj Nastaleeq', serif" } : {}}>
          <div className="container mx-auto px-4">
            <h2 className="text-3xl font-bold text-center mb-12 text-gray-900">
              {companyLanguage === 'ur' ? 'کھلی ملازمتوں' : 'Open Positions'}
            </h2>
            <div className="space-y-6">
              {jobOpenings.map((job) => (
                <div
                  key={job.id}
                  className="bg-white rounded-lg shadow-lg p-8 hover:shadow-xl transition-shadow duration-300"
                >
                  <div className="flex flex-col md:flex-row md:items-start md:justify-between gap-4 mb-4">
                    <div className="flex-1">
                      <h3 className="text-2xl font-bold text-gray-900 mb-2">
                        {isUrdu && job.titleUrdu ? job.titleUrdu : job.title}
                      </h3>
                      <div className="flex flex-wrap gap-3 text-sm text-gray-600 mb-4">
                        <span className="flex items-center gap-1">
                          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
                          </svg>
                          {isUrdu && job.departmentUrdu ? job.departmentUrdu : job.department}
                        </span>
                        <span className="flex items-center gap-1">
                          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                          </svg>
                          {isUrdu && job.locationUrdu ? job.locationUrdu : job.location}
                        </span>
                        <span className="flex items-center gap-1">
                          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                          </svg>
                          {isUrdu && job.typeUrdu ? job.typeUrdu : job.type}
                        </span>
                      </div>
                    </div>
                    <Link
                      to="/contact"
                      className="bg-brand-header hover:bg-emerald-800 text-white font-semibold px-6 py-3 rounded-lg transition transform hover:-translate-y-0.5 hover:shadow-lg whitespace-nowrap"
                    >
                      {companyLanguage === 'ur' ? 'درخواست دیں' : 'Apply Now'}
                    </Link>
                  </div>
                  <p className="text-gray-700 mb-4">
                    {isUrdu && job.descriptionUrdu ? job.descriptionUrdu : job.description}
                  </p>
                  <div>
                    <h4 className="font-semibold text-gray-900 mb-2">
                      {companyLanguage === 'ur' ? 'ضروریات:' : 'Requirements:'}
                    </h4>
                    <ul className="list-disc list-inside space-y-1 text-gray-600">
                      {(isUrdu && job.requirementsUrdu ? job.requirementsUrdu : job.requirements).map((req, index) => (
                        <li key={index}>{req}</li>
                      ))}
                    </ul>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="py-16 bg-brand-header text-white">
          <div className="container mx-auto px-4 text-center">
            <h2 className="text-3xl font-bold mb-4">
              {companyLanguage === 'ur' ? 'ہمارے ساتھ شامل ہوں' : 'Join Our Team'}
            </h2>
            <p className="text-xl mb-8 opacity-90">
              {companyLanguage === 'ur' 
                ? 'اگر آپ کوئی مناسب پوزیشن نہیں دیکھتے، تو بھی ہم سے رابطہ کریں!' 
                : "Don't see a position that fits? Still reach out to us!"}
            </p>
            <Link
              to="/contact"
              className="bg-brand-button hover:bg-yellow-300 text-gray-900 font-semibold px-8 py-3 rounded-lg transition transform hover:-translate-y-0.5 hover:shadow-lg inline-block"
            >
              {companyLanguage === 'ur' ? 'ہم سے رابطہ کریں' : 'Contact Us'}
            </Link>
          </div>
        </section>
      </div>
    </>
  );
}

export default Careers;

